import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React from 'react';
import Image from '@src/components/image';
import { illustration4 } from '@src/layouts/auth/assets';

const AsideContentBusiness = () => {
  return (
    // <Box className="ss-flex ss-flex-col ss-items-center ss-gap-10 ss-py-14">
    //   <Text variant="h1" className="ss-text-white ss-max-w-[350px] ss-text-center">
    //     Grow your business
    //   </Text>
    //   <Text variant="paragraphLarge" className="ss-text-white ss-text-center">
    //     Manage payments for your business and unlock a world of opportunities with one tool
    //   </Text>
    // </Box>
    <Box>
      <Image
        className="ss-w-full ss-mx-auto ss-h-[400px] ss-overflow-hidden ss-mb-5"
        imgClasses="ss-h-full object-cover"
        alt=""
        src={illustration4}
        variant="eager-load"
      />
      <Box className="ss-px-10">
        <Text variant="h4" className="ss-text-white">
          Grow your business
        </Text>
        <Text variant="paragraphLarge" className="ss-text-white">
          Manage payments for your business and unlock a world of opportunities with one tool
        </Text>
      </Box>
    </Box>
  );
};

export default AsideContentBusiness;
